import { Component, OnInit, Inject, OnDestroy } from "@angular/core";
import { Router } from "@angular/router";
import { opdEnvironment } from "../../../properties/opd-field-properties";
import { OPD_API_URL } from "../../../properties/opd-url-properties";
import { DatePipe } from "@angular/common";
import { MatTableDataSource } from "@angular/material/table";
import { MatSnackBar } from "@angular/material/snack-bar";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { IpatientSearch } from "../../../interface/IpatientSearch";
import { SearchHeaderService } from "../../../services/SsearchHeader.service";
import { Subscription } from "rxjs/internal/Subscription";
import { GeneralUrlService } from "../../../services/SgeneralUrl.service";
import { patientGetDataservice } from "../../../services/SpatientGetData.service";
import { OPD_CONST } from "../../../properties/opd-static-properties";
import { MasterUrlService } from "../../../services/SmasterUrl.service";
import { FormControl } from "@angular/forms";
import { MICROSERVICES } from "projects/lib/medcare-core-lib/src/lib/constants/web-services";
import { MultiLanguageService } from "projects/lib/medcare-core-lib/src/lib/core/multi-language/multi-language.service";
import { AuthService } from "projects/lib/medcare-core-lib/src/lib/services/auth.service";
import { AppBaseService } from "projects/lib/medcare-core-lib/src/lib/services/http.service";
import { SearchService } from "projects/lib/medcare-core-lib/src/lib/services/search.service";
import { UtilsService } from "projects/lib/medcare-core-lib/src/lib/services/utils.service";
import { thEnConverterService } from "projects/lib/medcare-core-lib/src/lib/services/thEnConverterService";
import { Langauge } from "projects/lib/medcare-core-lib/src/lib/enums/configuration-modules.enum";

@Component({
  selector: "app-patient-block-add",
  templateUrl: "./patient-block-add.component.html",
  styleUrls: ["./patient-block-add.component.scss"],
  providers: [DatePipe],
})
export class PatientBlockAddComponent implements OnInit, OnDestroy {
  public searched = false;
  public environment: any = opdEnvironment;
  public dropdownValues: any = {};
  search: IpatientSearch = {};
  dataSource: MatTableDataSource<any>;
  selectedPatient: any;
  selectedPhoto: any;
  selectedMRN: string;
  selectedName: string;
  selectedIDType: string;
  selectedIDNo: string;
  selectedGender: string;
  selectedAge: string;
  date: any;
  user: string;
  reason: string;
  remarks: string;
  selectedRemarks: string;
  selectedReason: string;
  showd: boolean = false;
  showborder: boolean = false;
  showdSelected: boolean = false;
  searchCount: any;
  allSearchResults: any[] = [];
  displayedColumns: string[] = OPD_CONST.displayColumnBlock;
  displayedBannerColumns: any[] = OPD_CONST.displayHeaderColumn;
  isVisible: boolean = false;
  searchList: any[] = [];
  filterType: string = OPD_CONST.filterType;
  showPatient: boolean = false;
  resourceURL: string = OPD_API_URL.M_ENCOUNTER_SEARCH;
  reasonSample: any[] = [];
  previousUrl: string = "";
  isMergePatient: boolean = false;
  private subscriptionList = new Subscription();
  reasonList: any[]=[];
  reasonSearch: FormControl = new FormControl();
  searchValue: string = "";
  patientId: string;
  isTyped: boolean=false;
  isShow: boolean = false;
  pateintDataList:any[]=[];
  langaugeValue:string="";

  constructor(
    public appBaseService: AppBaseService,
    public snackBar: MatSnackBar,
    private utilsService: UtilsService,
    public router: Router,
    public authService: AuthService,
    private datepipe: DatePipe,
    public dialogRef: MatDialogRef<PatientBlockAddComponent>,
    private langService: MultiLanguageService,
    public searchHead: SearchHeaderService,
    private searchService: SearchService,
    public generalApiService: GeneralUrlService,
    public patientDataService: patientGetDataservice,
    public masterApiService: MasterUrlService,
    private thConvertService: thEnConverterService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  /**
   *Load method and get user info
   *
   * @memberof PatientBlockAddComponent
   */
  ngOnInit() {
    this.langaugeValue=localStorage.getItem("lan")
    if(this.data.isMergePatient){
       this.patientId = this.data ? this.data.element.id :""
    }
    this.search.MRN="";
    this.subscriptionList.add(
    this.getSearchFilter()
    );
    this.getReasonList();
    this.isMergePatient = this.data.isMergePatient;
    this.authService.getUser().then((value: any) => {
      this.user = value.userName;
    });
    this.onChanges();
  }
  
  onChanges(){
    this.subscriptionList.add(
      this.reasonSearch.valueChanges.subscribe((value) => {
        this.reasonSample = this.reasonList.filter((i) =>
          i.desc.toString().toLowerCase().includes(value.toLowerCase())
        );
      })
    );
  }

  /**
   *Destroy method
   *
   * @memberof PatientBlockAddComponent
   */
  ngOnDestroy() {
   // this.searchService.setSearch([]);
    this.subscriptionList.unsubscribe();
  }

  /**
   *getSearch method for filtered patients
   *
   * @memberof PatientBlockAddComponent
   */
  public getSearchFilter() {
    this.subscriptionList.add(
      this.searchHead
        .getTypeSearch(OPD_API_URL.M_PAT_MERGE_SEARCH)
        .subscribe((data: any) => {
          this.searchList = [];
          this.searchList = this.searchHead.updateSearchHeader(data);
        })
    );
  }

  /**
   *It is the source of Reason data
   *
   * @memberof PatientRegistrationComponent
   */
  getReasonList() {
  this.appBaseService.setResourceURL(MICROSERVICES.MASTERS_SERVICE);
  this.appBaseService
    .getResource(OPD_API_URL.M_REASON_MASTER_QUERY_NEW+"PTBL",true)
    .subscribe((res) => {
      res.forEach((element) => {
        this.reasonSample.push(element);
        this.reasonList.push(element);
      });
    });
  }

  /**
   *Set search the patientdata
   *
   * @param {*} result
   * @memberof PatientBlockAddComponent
   */
  setSearch(result) {
    this.clearRecord();
    this.search = {};
    this.search.MRN = result.mrn;
    this.search.patientName = result.patientName;
    this.search.dob = result.dob;
    this.search.gender = result.gender ? result.gender.code : "";
    this.search.mobileNo = result.MobileNo;
    this.search.identificationType = result.identificationType
      ? result.identificationType.code
      : "";
    this.search.identificationID =
    result.identificationID ?  result.identificationID.replace(/[-\s]/g, ""): "";
    this.search.unit = result.unit;
    this.search.offset = 0;
    this.search.limit=10;
    this.search.country = result.country ? result.country.Code : "";
    this.search.state = result.state ? result.state.code : "";
    this.search.city = result.city ? result.city.code : "";
    this.search.pincode = result.pincode;
    this.search.startDate = result.fromDate;
    this.search.endDate = result.toDate;
    this.getSearchResultPatient();
  }

  getKeySearch(data: string) {
    if (data && data.trim() != "") 
      {
        this.search.MRN = data;
        this.getSearchResultPatient();
      }
  }

  /**
   *Clear Search Functionality
   *
   * @memberof PatientBlockAddComponent
   */
  clearSearch() {
    this.searchList.forEach((search) => {
      search.controls.forEach((control) => {
        this[control.name] = "";
      });
    });
  }

  /**
   *Search the patient result using API
   *
   * @memberof PatientBlockAddComponent
   */
  getSearchResultPatient() {
    const birthDate = this.search.dob
      ? this.datepipe.transform(this.search.dob, "yyyy-MM-dd")
      : "";
      
    let reqPayload =
      "identificationId=" +
      (this.search.identificationID ? this.search.identificationID : "") +
      "&name=" +
      (this.search.patientName ? this.search.patientName : "") +
      "&mrn=" +
      (this.search.MRN ? this.search.MRN : "") +
      "&gender=" +
      (this.search.gender ? this.search.gender : "") +
      "&city=" +
      (this.search.city ? this.search.city : "") +
      "&identificationType=" +
      (this.search.identificationType ? this.search.identificationType : "") +
      "&id=" +
      "&mobile=" +
      (this.search.mobileNo ? this.search.mobileNo : "") +
      "&birthDate=" +
      birthDate +
      "&offset=" +( this.search.offset ? this.search.offset :0) +
      "&size=" +( this.search.limit ? this.search.limit :10) +
      "&pincode=" +
      (this.search.pincode ? this.search.pincode : "") +
      "&country=" +
      (this.search.country ? this.search.country : "") +
      "&state=" +
      (this.search.state ? this.search.state : "");

    this.allSearchResults = [];
    this.subscriptionList.add(
      this.generalApiService
        .getTypeApi(
          OPD_API_URL.OPD_SERVICE,
          OPD_API_URL.OPD_PATIENT_SEARCH + reqPayload
        )
        .subscribe((res: any[]) => {
        if(this.data.isMergePatient){
          if(!res[0].merged){
            if(res[0].id == this.patientId){
              this.snackBar.open(
                this.langService.get("CommonAppoinment.samepatientmerged"),
                this.langService.get("CommonAppoinment.success"),
                {
                  duration: 2000,
                }
              );
            }else{
              this.pateintDataList = this.patientDataService.displayList(res);
              this.pateintDataList.forEach(element => {
                element.age=this.generalApiService.calculateAge(element.dateOfBirth)
                element.dateOfBirth= element.dateOfBirth
                ? (this.langaugeValue== Langauge.TH
                  ? this.thConvertService.convertToThaiFullDateWithOutTime(element.dateOfBirth)
                  : this.datepipe.transform(element.dateOfBirth, "dd-MM-yyyy"))
                : null
              });
              this.showd = true;
              this.showborder = true;
              this.showPatient = true;
              this.isShow = true;
              this.searchCount = this.pateintDataList.length;
              this.dataSource = new MatTableDataSource<any>(this.pateintDataList);
              this.clearSearch();
            }
        }else{
          this.snackBar.open(
            this.langService.get("CommonAppoinment.patientmerged"),
            this.langService.get("CommonAppoinment.success"),
            {
              duration: 2000,
            }
          );
        }
       }else { 
        if (this.search.gender) {
          let list = res.filter(patient => patient.isBlocked == false);
          list = this.patientDataService.displayList(list);
          this.showd = true;
          this.showborder = true;
          this.showPatient = true;
          this.dataSource = new MatTableDataSource<any>(list);
          this.clearSearch();
        } else {
          if(!res[0].isBlocked) {
            let pateintData = this.patientDataService.displayList(res);
            pateintData.forEach(element => {
              element.age=this.generalApiService.calculateAge(element.dateOfBirth)
              element.dateOfBirth= element.dateOfBirth
              ? (this.langaugeValue== Langauge.TH
                ? this.thConvertService.convertToThaiFullDateWithOutTime(element.dateOfBirth)
                : this.datepipe.transform(element.dateOfBirth, "dd-MM-yyyy"))
              : null
              
            });
            this.showd = true;
            this.showborder = true;
            this.isShow = true;
            this.showPatient = true;
            this.searchCount = pateintData.length;
            this.dataSource = new MatTableDataSource<any>(pateintData);
            this.clearSearch();
           }else{
              this.snackBar.open(
                this.langService.get("CommonAppoinment.patientBlocked"),
                this.langService.get("CommonAppoinment.success"),
                {
                  duration: 2000,
                }
              );
           }
          }
       }
  })
        );
      
      }

  /**
   *Clear record Daata
   *
   * @memberof PatientBlockAddComponent
   */
  clearRecord() {
    this.showborder = undefined;
    this.showd = undefined;
    this.allSearchResults = [];
    this.dataSource = new MatTableDataSource<any>(this.allSearchResults);
  }

  /**
   *Selected patient data
   *
   * @param {*} row
   * @memberof PatientBlockAddComponent
   */
  rowClicked(row) {
    this.selectedPatient = row;
    if (this.isMergePatient) {
      let data = this.selectedPatient;
      this.dialogRef.close(data);
    } else {
      if (this.showPatient) {
        let dobDate = new Date(this.selectedPatient.dateOfBirth);
        this.selectedPatient.age= row.age;
        this.selectedPatient.age = ( this.selectedPatient.age > 1)? ("(" +  this.selectedPatient.age + " Years)") : ("(" +  this.selectedPatient.age + " Year)");
        this.selectedPhoto = row.photo;
        this.selectedMRN = row.mrn;
        this.selectedName = row.fullName;
        this.selectedGender = row.gender;
        this.selectedPatient.dateOfBirth=row.dateOfBirth
        ?(this.langaugeValue== Langauge.TH
          ? this.thConvertService.convertThaiDateString(row.dateOfBirth)
                       : this.datepipe.transform(row.dateOfBirth, "dd/MM/yyyy")): null;
         if(this.selectedPatient.dateOfBirth){
      this.selectedPatient.dateOfBirth =
      this.selectedPatient.dateOfBirth?(this.langaugeValue== Langauge.TH
        ? this.thConvertService.convertThaiDateString(this.selectedPatient.dateOfBirth)
                     :  this.datepipe.transform(this.selectedPatient.dateOfBirth, 'dd/MM/yyyy'))
                     : null;
 
    }
      }
      this.showdSelected = true;
      this.clearRecord();
    }
  }

  /**
   *on return screen
   *
   * @memberof PatientBlockAddComponent
   */
  returnToScreen() {
    this.onCloseClick();
  }

  /**
   *Save block patient method
   *
   * @param {*} remarksValue
   * @param {*} reasonValue
   * @memberof PatientBlockAddComponent
   */
  onSaveBlock(remarksValue, reasonValue) {
    if (this.selectedPatient&&reasonValue) {
      let reason = this.reasonSample.find((i) => i.code == reasonValue);
      let reqPayload = {
        isBlocked: true,
        reason: reason ? this.langService.createObjectList(reason) : null,
        remarks: remarksValue,
      };
      this.subscriptionList.add(
        this.generalApiService
          .patchTypeApi(
            OPD_API_URL.OPD_SERVICE,
            OPD_API_URL.OPD_BLOCK_PATIENT + this.selectedPatient.id,
            reqPayload
          )
          .subscribe((response: any) => {
            if (response) {
              this.snackBar.open(
                this.langService.get("payerInfo.patientBlockedSuccefully"),
                this.langService.get("CommonAppoinment.success"),
                {
                  duration: 2000,
                }
              );
              this.onCloseClick();
            }
          })
      );
    } else {
      if(reasonValue==undefined||reasonValue=="")
      {
        this.snackBar.open(
         "Please select Reason",
          this.langService.get("CommonAppoinment.validation"),
          {
            duration: 2000,
          }
        );
      }
      else{
      this.snackBar.open(
        this.langService.get("payerInfo.pleaseSelectPatient"),
        this.langService.get("CommonAppoinment.validation"),
        {
          duration: 2000,
        }
      );
      }
    }
  }

  /**
   *patient search binding
   *
   * @param {{ url: string; methodName: string; name: string }} control
   * @param {(string | number)} parent
   * @param {(string | number)} child
   * @memberof PatientBlockAddComponent
   */
  selectOnClick(
    control: { url: string; methodName: string; name: string },
    parent: string | number,
    child: string | number
  ) {
    let tempUrl = "";
    try {
      let hasParam = false;
      if (
        control.url &&
        control.url.includes("{") &&
        control.url.includes("{") &&
        !control.url.includes("{UnitMaster}")
      ) {
        let param = control.url.substring(
          control.url.lastIndexOf("{") + 1,
          control.url.lastIndexOf("}")
        );

        let dependentValue: string = this.dropdownValues[param].toString();
        if (dependentValue) {
          tempUrl = control.url.replace(/\{.*?\}/, dependentValue.trim());
        } else {
          tempUrl = control.url.replace(/\{.*?\}/, "''");
        }
        hasParam = true;
      }
      if (
        !this.searchList[parent].controls[child].options ||
        this.searchList[parent].controls[child].options.length == 0 ||
        hasParam
      ) {
        if (control.url) {
          if (
            (!control.url.includes("{") && !control.url.includes("{")) ||
            !tempUrl
          ) {
            tempUrl = control.url;
          }
          if (tempUrl != this.previousUrl || !hasParam) {
            this.previousUrl = tempUrl;
            this.appBaseService.setResourceURL("/");
            this.subscriptionList.add(
              this.appBaseService.getResource(tempUrl).subscribe((res) => {
                this.searchList[parent].controls[child].options = res;
                setTimeout(() => {
                  document.getElementById(control.name).click();
                  document.getElementById("searchAutoComplete").focus();
                }, 500);
              })
            );
          }
        }
      }
    } catch (ex) {
      console.error(ex);
    }
  }

  /**
   *on selection change
   *
   * @param {*} name
   * @param {*} value
   * @memberof PatientBlockAddComponent
   */
  selectOnChange(name, value) {
    if (name && value) this.dropdownValues[name] = value.id;
  }

  /**
   *close window
   *
   * @memberof PatientBlockAddComponent
   */
  onCloseClick() {
    this.dialogRef.close();
  }
  clearText() {
    this.searchValue = "";
    this.isTyped = false;
  }

  showCloseIcon() {
    this.isTyped = this.searchValue ? true : false;
  }

  changeDropArrow() {
    this.isVisible = !this.isVisible;
  }
}
